import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getBeerStylesData} from 'services/beer-styles';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import BeerStyle from 'typescript/models/BeerStyle';

import {setBeerStylesAC, setBeerStylePageDataAC} from '../beerStyleSlice';
import {getBeerStylesACS} from '../requestAC';

export function* getBeerStyles(action: ReturnType<typeof getBeerStylesACS>) {
  try {
    const response: AxiosResponse<ApiData<BeerStyle[]>> = yield call(getBeerStylesData, action.payload);

    const {data} = response;

    yield put(setBeerStylePageDataAC({totalPages: data.meta.total_pages, totalCount: data.meta.total_count}));
    yield put(setBeerStylesAC(data.data));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DATA);
  }
}
